/* eslint-disable */
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import React, { useState, useEffect, useRef, useMemo, useCallback, useContext } from 'react';
import {
  Grid,
  Typography,
  TextField,
  Button,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  IconButton,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
  Slide,
  Checkbox,
  ClickAwayListener,
  TableCell,
  TableHead,
  TableRow,
  Popover,
  Link,
  FormControl,
  Select,
} from '@material-ui/core';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
// import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import MaterialTable from 'material-table';
/* CSS */
import { useNavigate } from 'react-router-dom';
import Moment from 'react-moment';
import moment from 'moment';
import useStyles from '../../Main.style';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { FastField, Formik, Form, Field } from 'formik';
import Autocomplete from '@material-ui/lab/Autocomplete';
import useForms from '../../../../hooks/useForms';
import usePractice from '../../../../hooks/usePractice';
import useQuickBook from '../../../../hooks/useQuickBook';
import FilterListIcon from '@material-ui/icons/FilterList';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import blankIMage from '../../../../assets/images/vgl-blank-image.png';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
/* Modal */
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CloseIcon from '@material-ui/icons/Close';
import { debounce, sortBy } from 'lodash';
import { FOCUS_MODE_EVENTS } from '../../../../constants/actionTypes';
import { FocusModeContext } from '../../../../contexts/focusModeContext';
import SortIcon from '@material-ui/icons/Sort';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
// import ToggleOffIcon from '@material-ui/icons/ToggleOffTwoTone';
// import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import Switch from '@material-ui/core/Switch';
import { Alert } from '@material-ui/lab';
const EmployeeScoreTable = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const {
    getCountry,
    getUserDetails,
    getCountriesCells,
    getDepartmentData,
    getAllFilters,
    deleteAllFilters,
    deleteSelectedFilter,
  } = usePractice();

  const { reportForQuarters } = useQuickBook();

  const key = 'iFrasCwdJh';
  const userCookie = Cookies.get('user');
  let bytes = CryptoJS.AES.decrypt(userCookie, key);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

  const theme = useTheme();
  const [openFilter, setOpenFilter] = React.useState(false);
  const [fpData, setFpData] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [filteredFpData, setFilteredFpData] = useState([]);
  const [filteredFpDataClone, setFilteredFpDataClone] = useState([]);
  const [isApplyClicked, setIsApplyClicked] = useState(false);
  const [filteredColumnList, setFilteredColumnList] = useState([]);
  const [countryList, setCountryList] = useState([]);
  const [loggedInUserDetails, setLoggedInUserDetails] = useState([]);
  const [cellListForFilter, setCellListForFilter] = useState([]);
  const [deptListForFilter, setDeptListForFilter] = useState([]);
  const [yearListForFilter, setYearListForFilter] = useState([]);
  const [selectedSearchId, setSelectedSearchId] = useState(null);
  const [selectedSearchIndex, setSelectedSearchIndex] = useState(null);
  const [selectedRankingField, setSelectedRankingField] = useState(null);
  // State declaration for filter components
  const SelectAllFields = { label: 'Select All' };
  const [selectedFieldOption, setSelectedFieldOption] = useState([]);

  const SelectAllCountries = { countryTitle: 'Select All' };
  const [selectedCountryOption, setSelectedCountryOption] = useState([]);

  const SelectAllCells = { cellTitle: 'Select All' };
  const [selectedCellOption, setSelectedCellOption] = useState([]);
  const [cellsByCountryIndicator, setCellsByCountryIndicator] = useState({});

  const SelectAllDepartments = { department: 'Select All' };
  const [selectedDepartmentOption, setSelectedDepartmentOption] = useState([]);
  //State declaration for filter components
  const [selectedValueCell, setSelectedValueCell] = React.useState(null);

  const [performanceReview, setPerformanceReview] = useState([]);
  const [filterSubmitted, setFilterSubmitted] = useState([]);
  const { getFinParamsUsers, getPerformanceReview } = useForms();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [submenuAnchorEl, setSubmenuAnchorEl] = useState(null);
  const [searchAnchorEl, setSearchAnchorEl] = React.useState(null);
  const [savedSearches, setSavedSearches] = useState([]);
  const [menuOpen, setMenuOpen] = useState(null);
  const [filterEditMode, setFilterEditMode] = useState(false);
  const reportData = [];
  let finDataAll = [];
  let yearFP = [];
  const [openFilterName, setOpenFilterName] = React.useState(false);
  const [openFilterRename, setOpenFilterRename] = React.useState(false);
  const [openFilterValidation, setOpenFilterValidation] = React.useState(false);
  const [openDeleteConfirmation, setOpenDeleteConfirmation] = React.useState(false);
  const [filterSelectedUpdate, setFilterSelectedUpdate] = React.useState({});
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [openCountry, setOpenCountry] = useState(false);
  const [openCountryClick, setOpenCountryClick] = React.useState(false);
  const [selectedSortItem, setSelectedSortItem] = React.useState({});
  const [scrollTop, setScrollTop] = useState(0);

  const [isFinAnalysisVisible, setIsFinAnalysisVisible] = useState(
    (loggedInUserData.department &&
      loggedInUserData.department?.departmentTitle.toLowerCase() == 'administrations') ||
      (loggedInUserData.department &&
        loggedInUserData.department?.departmentTitle.toLowerCase() == 'superadmin') ||
      loggedInUserData.roleId == 1,
  );
  const [hiddenColumns, setHiddenColumns] = useState([]);
  // const [isFocusMode, setIsFocusMode] = useState(false);
  const [isFocusMode, dispatchIsFocusMode] = useContext(FocusModeContext);
  const [showSnackBarErr, setShowSnackBarErr] = useState(false);
  // New Code
  const pageFpSizeOptions = [10, 20, 50, 100];

  const [currentFpPage, setCurrentFpPage] = useState(1);
  const [pageFpSize, setFpPageSize] = useState(20);

  const loadUser = async () => {
    const userDetail = await getUserDetails(loggedInUserData?.id);
    setLoggedInUserDetails(userDetail?.usersResult[0]);
  };

  const loadPerformanceReview = async () => {
    const performanceReviewResult = await getPerformanceReview();
    setPerformanceReview(performanceReviewResult?.usersResult);
  };

  const handleFpPageChange = (newFpPage) => {
    setCurrentFpPage(newFpPage);
  };

  const handleFpPageSizeChange = (newFpPageSize) => {
    setFpPageSize(newFpPageSize);
    setCurrentFpPage(1); // Reset to the first page when changing page size
  };

  const startFpIndex = (currentFpPage - 1) * pageFpSize;
  const endFpIndex = startFpIndex + pageFpSize;

  console.log(selectedSortItem.sortField, 6000);
  const displayedFpData = selectedSortItem.sortField
    ? filteredFpData.slice(startFpIndex, endFpIndex)
    : filteredFpDataClone.slice(startFpIndex, endFpIndex) || [];
  // New Code
  const handleSnackBarClose = () => {
    setShowSnackBarErr(false);
  };
  const handleFocusModeClick = () => {
    if (!isFocusMode.isFocusMode) {
      enterFullscreen();
    } else {
      exitFullscreen();
    }
    dispatchIsFocusMode({ type: FOCUS_MODE_EVENTS.SUCCESS, payload: !isFocusMode.isFocusMode });
    //onToggleFocusMode();
  };



  const enterFullscreen = () => {
    const element = document.documentElement;
    if (element.requestFullscreen) {
      element.requestFullscreen();
    } else if (element.webkitRequestFullscreen) {
      element.webkitRequestFullscreen();
    } else if (element.msRequestFullscreen) {
      element.msRequestFullscreen();
    }
  };

  const exitFullscreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen();
    }
  };

  const handleFullscreenChange = () => {
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.msFullscreenElement
    ) {
      // User is in fullscreen mode
      dispatchIsFocusMode({ type: FOCUS_MODE_EVENTS.SUCCESS, payload: true });
    } else {
      // User has exited fullscreen mode
      dispatchIsFocusMode({ type: FOCUS_MODE_EVENTS.SUCCESS, payload: false });
    }
  };
  const handleToggleColumn = (field) => {
    if (field) {
      setHiddenColumns((prevHiddenColumns) => {
        // hide column functionality
        const updatedHiddenColumns = prevHiddenColumns.includes(field)
          ? prevHiddenColumns.filter((column) => column !== field)
          : [...prevHiddenColumns, field];

        for (let i = 1; i < filteredColumnList.length; i++) {
          filteredColumnList[i].hidden = updatedHiddenColumns.includes(filteredColumnList[i].field);
        }
        return updatedHiddenColumns;
      });
    } else {
      setHiddenColumns([]);
      for (let i = 1; i < filteredColumnList.length; i++) {
        filteredColumnList[i].hidden = false;
      }

      // Unhide column functionality
    }
  };

  const clearAll = () => {
    filterFpData({
      country: null,
      cell: null,
    });
    // filterFpData();
    setSelectedCountryOption([]);
    setSelectedCellOption([]);
    setSelectedDepartmentOption([]);
    setSelectedFieldOption([]);
    setOpenFilter(false);
    setIsApplyClicked(false);
    setSelectedSortItem({});
    setLoaded(false);
    // setFilterEditMode(true);
  };
  
  const [filterName, setFilterName] = useState('');
  const [filterRename, setFilterRename] = useState('');
  const [isFilterNameValid, setFilterNameValid] = useState(true);
  const [isFilterRenameValid, setFilterRenameValid] = useState(true);


  const fieldOptions = [
    { label: 'Salary', value: 'salary' },
    { label: 'Bonuses', value: 'bonuses' },
    { label: 'Commissions', value: 'commissions' },
    { label: 'Benefits', value: 'benefits' },
  ];

  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [formQuestions, setFormQuestions] = useState([]);

  const [anchorMts, setAnchorMts] = React.useState([]);
  const [anchorPositions, setAnchorPositions] = React.useState([]);

  const handleMtMenuClick = (event, columnIndex) => {
    const updatedAnchorMts = [...anchorMts];
    updatedAnchorMts[columnIndex] = event.currentTarget;
    setAnchorMts(updatedAnchorMts);

    const updatedAnchorPositions = [...anchorPositions];
    updatedAnchorPositions[columnIndex] = { top: event.pageY - scrollTop, left: event.pageX };
    setAnchorPositions(updatedAnchorPositions);
  };

  const handleToggleOpen = (source) => {
    // //console.log(source, 2000);

    if (source == 'open') {
      setOpenCountry(true);
    } else if (source == 'close') {
      setOpenCountry(false);
    } else if ('changeEvent') {
      setOpenCountry(true);
    }
  };

  const handleMtMenuClose = (columnIndex) => {
    const updatedAnchorMts = [...anchorMts];
    updatedAnchorMts[columnIndex] = null;
    setAnchorMts(updatedAnchorMts);

    const updatedAnchorPositions = [...anchorPositions];
    updatedAnchorPositions[columnIndex] = null;
    setAnchorPositions(updatedAnchorPositions);
  };

  const calculateRank = (item, field) => {
    //console.log(filteredFpData, 100);
    let rankingFilteredFpData = [...filteredFpData];
    setSelectedRankingField(field);
    // rankingFilteredFpData.sort((a, b) => parseFloat(b[field]) - parseFloat(a[field]));
    // rankingFilteredFpData.forEach((obj, index) => {
    //   obj.ranking.rankValue = index + 1;
    // });

    rankingFilteredFpData = sortFloatValues(rankingFilteredFpData, field, 'sort down');
    rankingFilteredFpData.forEach((obj, index) => {
      obj.ranking.rankValue = index + 1;
    });
    //console.log(rankingFilteredFpData, 200);
    setFilteredFpData(rankingFilteredFpData);
  };

  const handleMenuItemClick = debounce((item, field, columnIndex) => {
    // //console.log('Selected item:', item.toLowerCase());
    // //console.log('Column field:', field);

    //Field Ranking from Ranking column
    if (columnIndex === 0) {
      calculateRank(item, field);
    }

    //Field Ranking from Ranking column

    //Ranking code
    if (item.toLowerCase() === 'show ranking') {
      calculateRank(item, field);
    }
    //Ranking code

    if (item.toLowerCase() === 'hide column') {
      handleToggleColumn(field);
    }
    //Hide Code
    //Sorting Code
    if (item.toLowerCase() == 'sort up' || item.toLowerCase() == 'sort down') {
      if (
        selectedSortItem?.sortType &&
        columnIndex === selectedSortItem?.sortColumnIndex &&
        item.toLowerCase() === selectedSortItem?.sortType
      ) {
        setSelectedSortItem({});
      } else {
        setSelectedSortItem({
          sortType: item.toLowerCase(),
          sortField: field,
          sortColumnIndex: columnIndex,
        });

        let sortItems = [...filteredFpData];
        if (item.toLowerCase() == 'sort up') {
          if (
            field === 'salary' ||
            field === 'bonuses' ||
            field === 'commissions' ||
            field === 'benefits'
          ) {
            sortItems = sortFloatValues(sortItems, field, 'sort up');
          } else {
            sortItems.sort((a, b) => {
              return compareNames(a[field], b[field]);
            });
          }

          setFilteredFpData(sortItems);
          // setFilteredFpData(sortItems);
        } else if (item.toLowerCase() == 'sort down') {
          if (
            field === 'salary' ||
            field === 'bonuses' ||
            field === 'commissions' ||
            field === 'benefits'
          ) {
            sortItems = sortFloatValues(sortItems, field, 'sort down');
          } else {
            sortItems.sort((a, b) => {
              return compareNames(b[field], a[field]);
            });
          }

          setFilteredFpData(sortItems);
          //setFilteredFpData(sortItems);
        }
      }
    }

    //Sorting code

    if (item.toLowerCase() === 'unhide columns') {
      handleToggleColumn();
    }
    handleMtMenuClose(columnIndex);
  }, 100);

  // Helper function to compare names considering undefined values
  const compareNames = (nameA, nameB) => {
    if (nameA === undefined && nameB === undefined) {
      return 0;
    }
    if (nameA === undefined) {
      return -1;
    }
    if (nameB === undefined) {
      return 1;
    }
    return nameA.localeCompare(nameB);
  };

  function formatNumberWithPrecision(value, precision) {
    return parseFloat(value).toFixed(precision);
  }

  const sortFloatValues = (sortItems, field, sortType) => {
    //console.log(field, 3000);
    if (!selectedRankingField) {
      setSelectedRankingField(field);
    }
    sortItems.sort((a, b) => {
      const strA = a[field];
      const strB = b[field];

      // Check if either strA or strB is NaN (not a number)
      const isStrANaN = isNaN(parseFloat(strA));
      const isStrBNaN = isNaN(parseFloat(strB));

      // Handle NaN cases first
      if (isStrANaN && isStrBNaN) {
        return 0; // Both values are NaN, so they are considered equal
      } else if (isStrANaN) {
        // strA is NaN, move it to the end regardless of sort type
        return 1;
      } else if (isStrBNaN) {
        // strB is NaN, move it to the end regardless of sort type
        return -1;
      }

      // At this point, both strA and strB are numeric values represented as strings

      const numA = parseFloat(strA.replace(/[^\d.-]/g, ''));
      const numB = parseFloat(strB.replace(/[^\d.-]/g, ''));

      const precision = 3; // Set the desired precision here

      if (sortType === 'sort up') {
        return (
          parseFloat(formatNumberWithPrecision(numA, precision)) -
          parseFloat(formatNumberWithPrecision(numB, precision))
        );
      } else if (sortType === 'sort down') {
        return (
          parseFloat(formatNumberWithPrecision(numB, precision)) -
          parseFloat(formatNumberWithPrecision(numA, precision))
        );
      }

      // If the sortType is not 'sort up' or 'sort down', return 0 to indicate no change
      return 0;
    });

    return sortItems;
  };

  const headerComponent = (column, columnIndex) => {
    return (
      <>
        <Box className={classes.RankingDetailTop}>
          {(columnIndex === 0 &&
            selectedRankingField &&
            selectedRankingField[0].toUpperCase() + selectedRankingField.slice(1).toLowerCase()) ||
            ''}
        </Box>
        <Box display="flex" alignItems="center">
          {column.title}

          <Button
            aria-controls={`menu-options-${column.field}`}
            aria-haspopup="true"
            onClick={(event) => handleMtMenuClick(event, columnIndex)}
          >
            <ExpandMoreIcon />
          </Button>
          {selectedSortItem?.sortColumnIndex === columnIndex &&
          selectedSortItem?.sortType == 'sort up' ? (
            <>
              <Box display="flex" className={classes.TableSortIcon}>
                <SortIcon />
              </Box>
            </>
          ) : selectedSortItem?.sortColumnIndex === columnIndex &&
            selectedSortItem?.sortType == 'sort down' ? (
            <>
              <Box display="flex" className={classes.TableSortIconClicked}>
                <SortIcon />
              </Box>
            </>
          ) : (
            ''
          )}
        </Box>
        <Popover
          className={classes.MoreOptionsV2}
          id={`menu-options-${column.field}`}
          anchorEl={anchorMts[columnIndex]}
          keepMounted
          open={Boolean(anchorMts[columnIndex])}
          onClose={() => handleMtMenuClose(columnIndex)}
          anchorReference="anchorPosition"
          anchorPosition={anchorPositions[columnIndex]}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <If condition={column.field !== 'ranking'}>
            <If condition={fieldOptions.some((field) => field?.value === column.field)}>
              <MenuItem
                onClick={() => handleMenuItemClick('show Ranking', column.field, columnIndex)}
              >
                Show Ranking
              </MenuItem>
            </If>
            <MenuItem
              className={
                selectedSortItem.sortType == 'sort up' &&
                selectedSortItem.sortColumnIndex === columnIndex
                  ? 'Mui-selected'
                  : ''
              }
              onClick={() => handleMenuItemClick('Sort Up', column.field, columnIndex)}
            >
              Sort Up
            </MenuItem>
            <MenuItem
              className={
                selectedSortItem.sortType == 'sort down' &&
                selectedSortItem.sortColumnIndex === columnIndex
                  ? 'Mui-selected'
                  : ''
              }
              onClick={() => handleMenuItemClick('Sort Down', column.field, columnIndex)}
            >
              Sort Down
            </MenuItem>
            <MenuItem onClick={() => handleMenuItemClick('Hide Column', column.field, columnIndex)}>
              Hide Column
            </MenuItem>
            <MenuItem
              disabled={hiddenColumns.length == 0}
              onClick={() => handleMenuItemClick('Unhide Columns', column.field, columnIndex)}
            >
              Unhide Columns
            </MenuItem>
          </If>

          <If condition={column.field == 'ranking'}>
            {fieldOptions.map((field) => {
              if (field.value !== 'selectAll') {
                //To Disable the field value in ranking column

                const searchValue = field?.value;
                const exists = filteredColumnList.some((obj) => obj.field === searchValue);

                return (
                  <>
                    <MenuItem
                      disabled={!exists}
                      onClick={() => handleMenuItemClick(field.value, field.value, 0)}
                    >
                      {field.label}
                    </MenuItem>
                  </>
                );
              }
            })}
          </If>
        </Popover>
      </>
    );
  };

  let columns = [
    {
      title: 'Ranking',
      field: 'ranking',
      render: (data) => {
        return <Box className={classes.RankingNumber}>{data?.ranking?.rankValue}</Box>;
      },
    },
    {
      title: 'Employee Name',
      field: 'employee',
      render: (data) => data?.employee,
      hidden: hiddenColumns.includes('employee'),
    },
    {
      title: 'Country',
      field: 'country',
      render: (data) => data?.country,
      hidden: hiddenColumns.includes('country'),
    },
    {
      title: 'Cell',
      field: 'cell',
      render: (data) => data?.cell,
      hidden: hiddenColumns.includes('cell'),
    },
    {
      title: 'Department',
      field: 'department',
      render: (data) => data?.department,
      hidden: hiddenColumns.includes('department'),
    },
    {
      title: 'Salary',
      field: 'salary',
      render: (data) => data?.salary,
      hidden: hiddenColumns.includes('salary'),
    },
    {
      title: 'Bonuses',
      field: 'bonuses',
      render: (data) => data?.bonuses,
      hidden: hiddenColumns.includes('bonuses'),
    },
    {
      title: 'Commissions',
      field: 'commissions',
      render: (data) => data?.commissions,
      hidden: hiddenColumns.includes('commissions'),
    },
    {
      title: 'Benefits',
      field: 'benefits',
      render: (data) => data?.benefits,
      hidden: hiddenColumns.includes('benefits'),
    },
  ];

  // const handleClickOpenFilterName = () => {
  //   setOpenFilterName(true);
  // };

  const renderHeader = () => {
    return (
      <tr>
        {filteredColumnList.map((column, columnIndex) => {
          if (column.field !== 'ranking' && !column.hidden) {
            return <td key={column.field}>{headerComponent(column, columnIndex)}</td>;
          } else if (column.field == 'ranking') {
            return <td key={column.field}>{headerComponent(column, columnIndex)}</td>;
          }
        })}
      </tr>
    );
  };

  const handleCloseFilterName = () => {
    setOpenFilterName(false);
    handleCloseFilterValidation();
    setFilterName('');
  };

  const handleCloseFilterValidation = async () => {
    setOpenFilterValidation(false);
  };

  const addSelClassToSearchButton = (index) => {
    const buttons = document.querySelectorAll(`[id^="button-"]`);
    const clickedButton = document.getElementById('button-' + index);
    const parentDiv = clickedButton.parentElement;
    buttons.forEach((button) => {
      if (button !== clickedButton) {
        const parentDiv = button.parentElement;
        parentDiv.classList.add(classes.TableInnerFilter);
        parentDiv.classList.remove(classes.TableInnerFilterSelect);
      }
    });

    parentDiv.classList.add(classes.TableInnerFilterSelect); // Add filterselected class to the clicked button
    parentDiv.classList.remove(classes.TableInnerFilter);
  };

  const handleSearchButtonClick = async (
    event,
    index,
    _id,
    _values,
    selectedSection,
    { resetForm },
  ) => {
    setHiddenColumns([]);
    const clickedButton = event.target.parentElement;
    const parentDiv = clickedButton.parentElement;
    const buttonId = `button-${index}`;
    const buttonArrowId = `buttonArrow-${index}`;
    const buttonElement = event.currentTarget;
    const buttonIdFromEvent = buttonElement.getAttribute('id');

    //Check if search is already clicked
    if (selectedSection == 'button') {
      setSelectedSearchIndex(index);
      setSelectedSearchId(_id);
      // setFilterEditMode(false);
      if (selectedSearchIndex == index) {
        clearSelectedSearch({ resetForm });
      } else {
        if (
          clickedButton.parentElement.tagName !== 'SPAN' &&
          !clickedButton.parentElement.id.includes('buttonArrow')
        ) {
          

          addSelClassToSearchButton(index);
          setFilterSelectedUpdate({});
          setFilterSelectedUpdate(savedSearches.filter((elem) => elem.id === _id));

          if (buttonId === buttonIdFromEvent) {
            const selectedSearchFlag = await loadSelectedSearch(_id, _values);
          }
        }
      }
    } else if (selectedSection == 'arrow') {
      //console.log('arrow clicked ::' + selectedSearchId);
      if (buttonArrowId === buttonIdFromEvent) {
        if (selectedSearchIndex == buttonArrowId.split('-')[1]) {
          setSearchAnchorEl(buttonElement);
        }
      }
    }
  };

  const loadSelectedSearch = async (_id, _values) => {
    const selectedSearch = savedSearches.filter((elem) => elem.id === _id);
    //new code
    clearAll();
    //new code
    _values['countryid'] = selectedSearch[0].country.length > 0 ? selectedSearch[0].country : [];
    _values['cellid'] = selectedSearch[0].cell.length > 0 ? selectedSearch[0].cell : [];
    _values['yearid'] = Number(selectedSearch[0].year);
    _values['period'] = selectedSearch[0].period;
    _values['deptid'] = selectedSearch[0].department.length > 0 ? selectedSearch[0].department : [];
    _values['fieldoptionid'] = selectedSearch[0].metrics || [];

    if (selectedSearch[0].country.length > 0) {
      let loadedCountries = [];
      selectedSearch[0].country.map((country) => {
        loadedCountries.push(JSON.parse(country));
      });

      await loadCellsForFilter(loadedCountries);
    }

    const loadedFpData = await loadFpData();

    setLoadedFilterOptions('cell', _values);

    fillReportState(loadedFpData);
    setFilterSubmitted(_values);
    const flagFilter = await filterFpData(_values);
    return flagFilter;
  };

  const setLoadedFilterOptions = (field, _values) => {
    // //console.log(_values, 4444);
    setSelectedFieldOption([]);
    setSelectedCountryOption([]);
    setSelectedCellOption([]);
    setSelectedDepartmentOption([]);

    const fieldToLoad = fieldOptions
      .map((field) => {
        if (_values['fieldoptionid'].some((f) => f === field.value)) {
          return field;
        }
      })
      .filter((field) => field !== undefined);

    setSelectedFieldOption(fieldToLoad);

    const countryToLoad = _values['countryid'].map((country) => {
      return JSON.parse(country);
    });
    setSelectedCountryOption(countryToLoad);

    const cellsToLoad = _values['cellid'].map((cell) => {
      return JSON.parse(cell);
    });
    setSelectedCellOption(cellsToLoad);

    const deptsToLoad = _values['deptid'].map((department) => {
      return JSON.parse(department);
    });
    setSelectedDepartmentOption(deptsToLoad);
  };

  const handleMenuClose = () => {
    setSearchAnchorEl(null); // Close the menu
  };

  const handleOutsideClick = () => {
    //setSearchAnchorEl(null); // Close the menu when clicked outside
  };
  const handleDeleteSearch = (searchId, { resetForm }) => {
    //console.log(searchId);
    const result = deleteSelectedFilter({ userId: loggedInUserData?.id, searchId: searchId });

    if (result) {
      clearAll();
      loadAllFilters();
      handleMenuClose();
      clearSelectedSearch({ resetForm });
    }
    // setFilterSelectedUpdate({});
    // handleMenuClose();
    // setFilteredFpData([]);
    // setIsApplyClicked(false);
  };

  const openDeleteConfirmationBox = async () => {
    handleSubmenuClose();
    setOpenDeleteConfirmation(true);
    handleClose();
  };

  const handleDeleteSavedSearches = async ({ resetForm }, isDeleteAll) => {
    handleSubmenuClose();
    closeDeleteConfirmation();
    //Actual Delete code
    if (isDeleteAll) {
      const result = await deleteAllFilters({ userId: loggedInUserData?.id });
      if (result) {
        loadAllFilters();
        clearSelectedSearch({ resetForm });
      }
    } else {
      handleDeleteSearch(selectedSearchId, { resetForm });
    }
  };

  const closeDeleteConfirmation = async () => {
    setOpenDeleteConfirmation(false);
  };
  const handleRenameButton = (_id) => {
    handleMenuClose();
    setOpenFilterRename(true);
    setFilterSelectedUpdate({});
    if (savedSearches && savedSearches.length > 0) {
      setFilterRename(savedSearches.filter((elem) => elem.id === _id)[0]?.filterName);
      setFilterSelectedUpdate(savedSearches.filter((elem) => elem.id === _id));
    }
  };
  const handleCloseFilterRename = () => {
    setOpenFilterRename(false);
    setFilterSelectedUpdate({});
  };
  const loadFpData = async () => {
    finDataAll = await getFinParamsUsers();
    //fillReportState(finDataAll);
    return finDataAll;
  };

  const loadCountries = async () => {
    const countryLists = await getCountry();
    if (countryLists.usersResult) {
      // countryLists.usersResult.unshift({ id: '1', countryTitle: 'Select All' });
      setCountryList(countryLists.usersResult);
    }
  };

  const loadCellsForFilter = async (countryIdList) => {
    if (countryIdList.length > 0) {
      const CellList = await getCountriesCells(countryIdList);
      // CellList.usersResult.unshift({ id: '1', cellTitle: 'Select All' });
      setCellListForFilter(CellList.usersResult);
    } else {
      setCellListForFilter([]);
    }
  };

  const loadDeptForFilter = async () => {
    const DeptList = await getDepartmentData();
    if (DeptList.usersResult) {
      // DeptList.usersResult.unshift({ id: '1', department: 'Select All' });
      setDeptListForFilter(DeptList.usersResult);
    }
  };

  const loadYearForFilter = async () => {
    const currentYear = new Date().getFullYear();
    const startYear = 2019;
    const numberOfYears = currentYear - startYear + 1;

    const yearsArray = Array.from({ length: numberOfYears }, (_, index) => {
      return {
        id: (index % 6) + 1,
        year: (startYear + index).toString(),
      };
    });

    setYearListForFilter(yearsArray);
    return yearsArray;
  };

  const fillReportState = async (formResponse) => {
    if (formResponse?.usersResult !== undefined && formResponse?.usersResult !== null) {
      const reponseByYear = Object.values(
        formResponse?.usersResult.reduce((acc, obj) => {
          const key = obj.formTrackerId;
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(obj);
          return acc;
        }, {}),
      );

      let formValues = {};

      reponseByYear.map((year) => {
        year.map((ans) => {
          let questionText = ans?.text;
          if (
            questionText ===
            "Bonuses – After break up with Kronoz (Dec - 2012) : Sales' Commissions"
          ) {
            formValues['bonuses'] = parseFloat(ans?.answer).toLocaleString(undefined, {
              maximumFractionDigits: 3,
            });
          } else if (questionText === "Other: Loan/Sales' Commissions") {
            formValues['commissions'] = ans?.answer
              ? parseFloat(ans?.answer).toLocaleString(undefined, { maximumFractionDigits: 3 })
              : '';
          } else if (questionText === 'Salary – total $ paid each year before taxes') {
            formValues['salary'] = ans?.answer
              ? parseFloat(ans?.answer).toLocaleString(undefined, { maximumFractionDigits: 3 })
              : '';
          } else if (questionText === 'Benefits – total $ paid by VGL for healthcare') {
            formValues['benefits'] = ans?.answer
              ? parseFloat(ans?.answer).toLocaleString(undefined, { maximumFractionDigits: 3 })
              : '';
          } else {
            formValues[questionText] = ans?.answer ? ans?.answer : '';
          }
          // formValues['employee'] = (<> <a
          //   onClick={() => {
          //     navigate(
          //       '../../view-employee/' +
          //       ans?.userDetails?.id +
          //         '/' +
          //         ans?.userDetails?.country?.id,
          //     );
          //   }}
          // >ans?.firstName + ' ' + ans?.lastName </a></>);
          formValues['employee'] = ans?.firstName + ' ' + ans?.lastName;
          formValues['employeeId'] = ans?.userDetails?.id;
          formValues['country'] = ans?.userDetails?.country?.countryTitle;
          formValues['cell'] = ans?.userDetails?.cell?.cellTitle;
          formValues['department'] = ans?.userDetails?.department?.departmentTitle;

          // if (!yearFP.includes(year[0]?.year)) yearFP.push(year[0]?.year);
        });

        formValues['year'] = year[0]?.year;
        reportData.push(formValues);
        formValues = {};
      });

      setFpData(reportData);
      setFilteredFpData(reportData);
    }
    
  };

  const filterFields = (_fpDAta, _fieldArray) => {
    const fieldArrayElements = new Set(_fieldArray);

    // Iterate over array1 and remove unwanted properties
    const result = _fpDAta.map((obj) => {
      const newObj = {};

      for (const prop in obj) {
        if (
          fieldArrayElements.has(prop) ||
          prop === 'employee' ||
          prop === 'country' ||
          prop === 'cell' ||
          prop === 'department'
        ) {
          newObj[prop] = obj[prop];
        }
      }

      return newObj;
    });

    return result;
  };

  const isValidJSON = (obj) => {
    try {
      JSON.parse(obj);
      return true;
    } catch (error) {
      return false;
    }
  };

  function mergeObjects(obj1, obj2) {
    const mergedObj = {};

    const mergeValues = (value1, value2) => {
      if (Array.isArray(value1) && Array.isArray(value2)) {
        if (value1.length >= value2.length) {
          return value1;
        } else {
          return value2;
        }
      } else if (Array.isArray(value2)) {
        return value2;
      }
      return value1 !== undefined ? value1 : [];
    };

    for (let prop in obj1) {
      if (obj1.hasOwnProperty(prop)) {
        mergedObj[prop] = mergeValues(obj1[prop], obj2[prop]);
      }
    }

    for (let prop in obj2) {
      if (obj2.hasOwnProperty(prop)) {
        if (!(prop in mergedObj)) {
          mergedObj[prop] = mergeValues(obj1[prop], obj2[prop]);
        }
      }
    }

    return mergedObj;
  }

  function mergeArrToObject(obj1, obj2) {
    const mergedObj = {};

    for (let prop in obj1) {
      if (obj1.hasOwnProperty(prop)) {
        if (Array.isArray(obj1[prop]) && Array.isArray(obj2[prop])) {
          const mergedArray = [...obj1[prop], ...obj2[prop]];
          mergedObj[prop] = mergedArray;
        } else {
          mergedObj[prop] = obj1[prop];
        }
      }
    }

    for (let prop in obj2) {
      if (obj2.hasOwnProperty(prop)) {
        if (!(prop in mergedObj)) {
          mergedObj[prop] = obj2[prop];
        } else if (Array.isArray(obj2[prop]) && !Array.isArray(mergedObj[prop])) {
          mergedObj[prop] = obj2[prop];
        } else if (typeof obj2[prop] === 'object') {
          mergedObj[prop] = mergeObjects(mergedObj[prop], obj2[prop]);
        }
      }
    }

    return mergedObj;
  }
  const filterFpData = async (filter) => {
    setOpenFilter(false);

    let filteredFpData = [];

    if (filter?.countryid) {
      const searchDataset =
        filteredFpData.length > 0 ? filteredFpData : fpData.length === 0 ? reportData : fpData;
      const parsedCountryIds = filter.countryid.reduce((acc, c) => {
        if (isValidJSON(c)) {
          acc.push(JSON.parse(c));
        } else {
          acc.push(c);
        }
        return acc;
      }, []);

      filteredFpData = searchDataset.filter((elem) =>
        parsedCountryIds.find((parsedId) => parsedId.countryTitle === elem.country),
      );
    }
    //console.log(filteredFpData, 1111);
    if (filter?.cellid) {
      const searchDataset =
        filteredFpData.length > 0 ? filteredFpData : fpData.length === 0 ? reportData : fpData;

      const parsedCellIds = filter.cellid.reduce((acc, c) => {
        if (isValidJSON(c)) {
          acc.push(JSON.parse(c));
        } else {
          acc.push(c);
        }
        return acc;
      }, []);
      if (parsedCellIds.length > 0) {
        filteredFpData = searchDataset.filter((elem) =>
          parsedCellIds.find((parsedId) => parsedId.cellTitle === elem.cell),
        );
      }
    }
    //console.log(filteredFpData, 2222);
    if (filter?.deptid) {
      // const searchDataset =
      //   filteredFpData.length > 0 ? filteredFpData : fpData.length === 0 ? reportData : fpData;
      let searchDataset = filteredFpData;

      if (filter?.deptid.length > 0 && filter?.cellid.length > 0 && filter?.countryid.length > 0) {
        filteredFpData = searchDataset.filter((elem) =>
          filter?.deptid.find((c) => {
            if (isValidJSON(c)) {
              return JSON.parse(c).department === elem.department;
            } else {
              return c.department === elem.department;
            }
          }),
        );
      } else if (
        filter?.deptid.length > 0 &&
        filter?.fieldoptionid &&
        filter?.fieldoptionid.length > 0 &&
        filter?.countryid == 0 &&
        filter?.cellid == 0
      ) {
        searchDataset =
          filteredFpData.length > 0 ? filteredFpData : fpData.length === 0 ? reportData : fpData;
        filteredFpData = searchDataset.filter((elem) =>
          filter?.deptid.find((c) => {
            if (isValidJSON(c)) {
              return JSON.parse(c).department === elem.department;
            } else {
              return c.department === elem.department;
            }
          }),
        );
      }

      // if (filteredFpData.length == 0) {
      //   filteredFpData = searchDataset;
      // }
    }
    //console.log(filteredFpData, 3333);
    if (filter?.yearid) {
      const yearObj = yearListForFilter.length
        ? yearListForFilter.find((obj) => obj.id === filter?.yearid)
        : await loadYearForFilter().find((obj) => obj.id === filter?.yearid);

      // const searchDataset =
      //   filteredFpData.length > 0 ? filteredFpData : fpData.length === 0 ? reportData : fpData;
      const searchDataset = filteredFpData.length > 0 ? filteredFpData : [];
      filteredFpData = searchDataset.filter((l) => {
        return l?.year === yearObj.year;
      });
    }
    //console.log(filteredFpData, 4444);
    if (filter?.fieldoptionid) {
      // filteredFpData = filterFields(
      //   filteredFpData.length > 0 ? filteredFpData : fpData.length === 0 ? reportData : fpData,
      //   filter?.fieldoptionid,
      // );
      filteredFpData = filterFields(
        filteredFpData.length > 0 ? filteredFpData : [],
        filter?.fieldoptionid,
      );

      // console.log(fieldOptions, 2000);
      // Default Sorting option when search result is loaded - Begin
      filteredFpData = sortFloatValues(
        filteredFpData,
        fieldOptions[1].value ||
          fieldOptions[2].value ||
          fieldOptions[3].value ||
          fieldOptions[4].value,
        'sort down',
      );
      // console.log(filteredFpData, 3000);
      filteredFpData.map((fpRecord, rankIndex) => {
        fpRecord['ranking'] = { fieldSelected: '', rankValue: rankIndex + 1 };
      });
      // console.log(filteredFpData, 4000);
      filteredFpData.sort((a, b) => {
        return compareNames(a['employee'], b['employee']);
      });
      //console.log(filteredFpData, 2000);
      // Default Sorting option when search result is loaded - End

      // Get all existing properties in filteredFieldData
      const existingProperties = filteredFpData
        ? filteredFpData.reduce((properties, data) => {
            Object.keys(data).forEach((property) => {
              if (!properties.includes(property)) {
                properties.push(property);
              }
            });
            return properties;
          }, [])
        : [];

      const filteredColumns = columns.filter((column) => {
        return existingProperties.includes(column.field);
      });
      setFilteredColumnList(filteredColumns);
    }
    // console.log(filteredFpData, 5555);
    setFilteredFpData(filteredFpData);
    setFilteredFpDataClone(filteredFpData);
    return true;
  };

  const loadAllFilters = async () => {
    if (loggedInUserData) {
      const filterData = await getAllFilters({ userId: loggedInUserData?.id });
      setSavedSearches(filterData.usersResult);
    }
  };

  const clearSelectedSearch = ({ resetForm }) => {
    //console.log('clearSelectedSearch');
    setSelectedSearchIndex(null);
    setSelectedSearchId(null);
    setFilterEditMode(false);
    removeButtonSelection();
    clearAll();
    resetForm();
  };
  const removeButtonSelection = () => {
    const buttons = document.querySelectorAll(`[id^="button-"]`);
    buttons.forEach((button) => {
      const parentDiv = button.parentElement;
      parentDiv.classList.add(classes.TableInnerFilter);
      parentDiv.classList.remove(classes.TableInnerFilterSelect);
    });
  };
  // IMP - Recursive function for mining FInancial Progression data from raw profit and loss report of Quick books for selected years
  function findParentObjectBySearchText(obj, searchText, parentObj = null) {
    if (typeof obj === 'object') {
      if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; i++) {
          var result = findParentObjectBySearchText(obj[i], searchText, obj);
          if (result) {
            return result;
          }
        }
      } else {
        for (var prop in obj) {
          if (obj.hasOwnProperty(prop)) {
            var result = findParentObjectBySearchText(obj[prop], searchText, obj);
            if (result) {
              return result;
            }
            if (
              typeof obj[prop] === 'string' &&
              obj[prop].toLowerCase().indexOf(searchText.toLowerCase()) !== -1
            ) {
              return { object: obj, parent: parentObj };
            }
          }
        }
      }
    }
    return null;
  }

  const getQbData = async (_reportData) => {
    const quartersData = await reportForQuarters();

    quartersData.reportResult.map((quarter, index) => {
      _reportData.map((emp) => {});
    });

    
  };

  const cellsInCountryIndicator = (cellData) => {
    const updatedCellsByCountry = {};
    cellData.forEach(({ cellTitle, countryId }) => {
      const country = selectedCountryOption.find(({ id }) => id === countryId);
      if (country) {
        if (!updatedCellsByCountry[country.countryTitle]) {
          updatedCellsByCountry[country.countryTitle] = new Set([cellTitle]);
        } else {
          updatedCellsByCountry[country.countryTitle].add(cellTitle);
        }
      }
    });
    setCellsByCountryIndicator(updatedCellsByCountry);
  };

  useEffect(() => {
    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('msfullscreenchange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('msfullscreenchange', handleFullscreenChange);
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        exitFullscreen();
        setIsFocusMode(false);
      }
    };

    document.addEventListener('keydown', handleKeyDown);

    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  useEffect(() => {
    console.log(filterSubmitted);
  }, [filterSubmitted]);


  useEffect(() => {
    console.log(selectedSortItem);
  }, [selectedSortItem]);
  useEffect(() => {
    loadPerformanceReview();
  }, []);
  useEffect(() => {
    loadUser();
  }, []);

  useEffect(() => {
    loadCountries();
  }, []);

  useEffect(() => {
    loadDeptForFilter();
  }, []);

  useEffect(() => {
    loadAllFilters();
  }, [openFilterRename]);

  useEffect(() => {
    cellsInCountryIndicator(selectedCellOption);
  }, [selectedCountryOption, selectedCellOption, selectedDepartmentOption, selectedFieldOption]);

  useEffect(() => {
    loadYearForFilter();
  }, []);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        !event.target.closest('#countryAutoComplete') &&
        !event.target.closest('#country-popup') &&
        !event.target.closest('#countryAutoCompleteMob')
      ) {
        // Clicked outside of .your-element-class, do something...countryAutoCompleteMob
        setOpenCountry(false);
        setOpenCountryClick(false);
      }
      if (event.target.closest('#countryAutoComplete')) {
        if (openCountry) {
          setOpenCountryClick(true);
        }

        if (openCountryClick && openCountry) {
          setOpenCountryClick(false);
          setOpenCountry(false);
        }
      }
    }

    // Attach the event listener on component mount
    window.addEventListener('click', handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [openCountryClick, openCountry]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setScrollTop(scrollTop);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const isMobile = useMediaQuery(theme.breakpoints.down('xs'), {
    defaultMatches: true,
  });

  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });
  const handleClickOpenFilter = () => {
    setOpenFilter(true);
  };
  const handleCloseFilter = () => {
    setOpenFilter(false);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setSubmenuAnchorEl(null);
    setOpenFilterValidation(false);
  };
  const handleSubmenuClick = (event) => {
    setSubmenuAnchorEl(event.currentTarget); // Set anchor element for submenu
  };

  const handleSubmenuClose = () => {
    setSubmenuAnchorEl(null); // Close submenu by resetting the anchor element
  };
  return (
    <>
      <Grid item xs={12} className={classes.innercontent}>
                            <Grid container style={{ height: '100%' }}>
                              <Grid item xs={12}>
                                <Grid container spacing={2}>
                                  <Grid item xs={12}>
                                    <Grid container direction="row">
                                      <Grid item xs={12} className={classes.FilterButtonMobile}>
                                        <Box>
                                          <Button
                                            startIcon={<FilterListIcon />}
                                            color="primary"
                                            onClick={handleClickOpenFilter}
                                          >
                                            Filters
                                          </Button>
                                          <If condition={openFilter}>
                                            <Dialog
                                              fullScreen
                                              open={openFilter}
                                              onClose={handleCloseFilter}
                                              TransitionComponent={Transition}
                                            >
                                              <DialogTitle id="simple-dialog-title">
                                                <Box display="flex" justifyContent="space-between">
                                                  <Box onClick={handleCloseFilter}>Clear All</Box>
                                                  <Box>
                                                    <b>Filters</b>
                                                  </Box>
                                                  <Box onClick={handleCloseFilter}>Cancel</Box>
                                                </Box>
                                              </DialogTitle>
                                              <DialogContent>
                                                <Grid container spacing={2}>
                                                  <Grid item xs={12} sm={4} md={2}>
                                                    <Autocomplete
                                                      multiple
                                                      id="patients"
                                                      options={ []}
                                                      disableCloseOnSelect
                                                      getOptionLabel={(option) => option.title}
                                                      renderTags={() => {}}
                                                      value={''}
                                                      getOptionSelected={(option, value) =>
                                                        option.title === value.title
                                                      }
                                                      onChange={(e, value) => {
                                                        addFiltersToPractice(
                                                          value ? value : '',
                                                          'patients',
                                                        );
                                                        setNewValueToFilter(value);
                                                        setNoOfPatientsOptionValue(value);
                                                      }}
                                                      renderOption={(option, { selected }) => (
                                                        <React.Fragment>
                                                          <Checkbox
                                                            icon={icon}
                                                            checkedIcon={checkedIcon}
                                                            style={{ marginRight: 8 }}
                                                            checked={
                                                              filtersForPractice &&
                                                              filtersForPractice.patients &&
                                                              filtersForPractice.patients.indexOf(
                                                                option.value,
                                                              ) > -1
                                                                ? true
                                                                : false
                                                            }
                                                          />
                                                          {option.title}
                                                        </React.Fragment>
                                                      )}
                                                      renderInput={(params) => (
                                                        <TextField
                                                          {...params}
                                                          label="Metric"
                                                          name="patients"
                                                          variant="outlined"
                                                        />
                                                      )}
                                                      popupIcon={<ExpandMoreIcon />}
                                                    />
                                                  </Grid>
                                                  <Grid item xs={12} sm={4} md={2}>
                                                    <Autocomplete
                                                      multiple
                                                      id="patients"
                                                      options={ []}
                                                      disableCloseOnSelect
                                                      getOptionLabel={(option) => option.title}
                                                      renderTags={() => {}}
                                                      value={''}
                                                      getOptionSelected={(option, value) =>
                                                        option.title === value.title
                                                      }
                                                      onChange={(e, value) => {
                                                        addFiltersToPractice(
                                                          value ? value : '',
                                                          'patients',
                                                        );
                                                        setNewValueToFilter(value);
                                                        setNoOfPatientsOptionValue(value);
                                                      }}
                                                      renderOption={(option, { selected }) => (
                                                        <React.Fragment>
                                                          <Checkbox
                                                            icon={icon}
                                                            checkedIcon={checkedIcon}
                                                            style={{ marginRight: 8 }}
                                                            checked={
                                                              filtersForPractice &&
                                                              filtersForPractice.patients &&
                                                              filtersForPractice.patients.indexOf(
                                                                option.value,
                                                              ) > -1
                                                                ? true
                                                                : false
                                                            }
                                                          />
                                                          {option.title}
                                                        </React.Fragment>
                                                      )}
                                                      renderInput={(params) => (
                                                        <TextField
                                                          {...params}
                                                          label="Country"
                                                          name="patients"
                                                          variant="outlined"
                                                        />
                                                      )}
                                                      popupIcon={<ExpandMoreIcon />}
                                                    />
                                                  </Grid>
                                                  <Grid item xs={12} sm={4} md={2}>
                                                    <Autocomplete
                                                      multiple
                                                      id="net_total_input"
                                                      options={ []}
                                                      disableCloseOnSelect
                                                      getOptionLabel={(option) => option.title}
                                                      onChange={(e, value) => {
                                                        addFiltersToPractice(
                                                          value ? value : '',
                                                          'netTotal',
                                                        );
                                                        setNewValueToFilter(value);

                                                        setNetTotalOptionsValue(value);
                                                      }}
                                                      value={''}
                                                      getOptionSelected={(option, value) =>
                                                        option.title === value.title
                                                      }
                                                      renderTags={() => {}}
                                                      renderOption={(option, { selected }) => (
                                                        <React.Fragment>
                                                          <Checkbox
                                                            icon={icon}
                                                            checkedIcon={checkedIcon}
                                                            style={{ marginRight: 8 }}
                                                            checked={
                                                              filtersForPractice &&
                                                              filtersForPractice.netTotal &&
                                                              filtersForPractice.netTotal.indexOf(
                                                                option.value,
                                                              ) > -1
                                                                ? true
                                                                : false
                                                            }
                                                          />
                                                          {option.title}
                                                        </React.Fragment>
                                                      )}
                                                      renderInput={(params) => (
                                                        <TextField
                                                          {...params}
                                                          variant="outlined"
                                                          label="Cell"
                                                        />
                                                      )}
                                                      popupIcon={<ExpandMoreIcon />}
                                                    />
                                                  </Grid>
                                                </Grid>
                                              </DialogContent>
                                              <DialogActions>
                                                <Button
                                                  variant="contained"
                                                  color="primary"
                                                  onClick={handleCloseFilter}
                                                  fullWidth
                                                >
                                                  Apply
                                                </Button>
                                              </DialogActions>
                                            </Dialog>
                                          </If>
                                        </Box>
                                      </Grid>

                                      <Grid
                                        item
                                        xs={12}
                                        className={classes.FilterDesktop}
                                        style={{ paddingTop: '16px' }}
                                      >
                                        <Grid container spacing={2}>
                                          <Grid item xs={12} sm={4} md={2}>
                                            <Autocomplete
                                              multiple
                                              id="patients"
                                              options={[]}
                                              disableCloseOnSelect
                                              getOptionLabel={(option) => option.title}
                                              renderTags={() => {}}
                                              value={''}
                                              getOptionSelected={(option, value) =>
                                                option.title === value.title
                                              }
                                              onChange={(e, value) => {
                                                addFiltersToPractice(
                                                  value ? value : '',
                                                  'patients',
                                                );
                                                setNewValueToFilter(value);
                                                setNoOfPatientsOptionValue(value);
                                              }}
                                              renderOption={(option, { selected }) => (
                                                <React.Fragment>
                                                  <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={
                                                      filtersForPractice &&
                                                      filtersForPractice.patients &&
                                                      filtersForPractice.patients.indexOf(
                                                        option.value,
                                                      ) > -1
                                                        ? true
                                                        : false
                                                    }
                                                  />
                                                  {option.title}
                                                </React.Fragment>
                                              )}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  label="Metric"
                                                  name="patients"
                                                  variant="outlined"
                                                />
                                              )}
                                              popupIcon={<ExpandMoreIcon />}
                                            />
                                          </Grid>
                                          <Grid item xs={12} sm={4} md={2}>
                                            <Autocomplete
                                              multiple
                                              id="patients"
                                              options={ []}
                                              disableCloseOnSelect
                                              getOptionLabel={(option) => option.title}
                                              renderTags={() => {}}
                                              value={''}
                                              getOptionSelected={(option, value) =>
                                                option.title === value.title
                                              }
                                              onChange={(e, value) => {
                                                addFiltersToPractice(
                                                  value ? value : '',
                                                  'patients',
                                                );
                                                setNewValueToFilter(value);
                                                setNoOfPatientsOptionValue(value);
                                              }}
                                              renderOption={(option, { selected }) => (
                                                <React.Fragment>
                                                  <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={
                                                      filtersForPractice &&
                                                      filtersForPractice.patients &&
                                                      filtersForPractice.patients.indexOf(
                                                        option.value,
                                                      ) > -1
                                                        ? true
                                                        : false
                                                    }
                                                  />
                                                  {option.title}
                                                </React.Fragment>
                                              )}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  label="Country"
                                                  name="patients"
                                                  variant="outlined"
                                                />
                                              )}
                                              popupIcon={<ExpandMoreIcon />}
                                            />
                                          </Grid>
                                          <Grid item xs={12} sm={4} md={2}>
                                            <Autocomplete
                                              multiple
                                              id="net_total_input"
                                              options={ []}
                                              disableCloseOnSelect
                                              getOptionLabel={(option) => option.title}
                                              onChange={(e, value) => {
                                                addFiltersToPractice(
                                                  value ? value : '',
                                                  'netTotal',
                                                );
                                                setNewValueToFilter(value);

                                                setNetTotalOptionsValue(value);
                                              }}
                                              value={''}
                                              getOptionSelected={(option, value) =>
                                                option.title === value.title
                                              }
                                              renderTags={() => {}}
                                              renderOption={(option, { selected }) => (
                                                <React.Fragment>
                                                  <Checkbox
                                                    icon={icon}
                                                    checkedIcon={checkedIcon}
                                                    style={{ marginRight: 8 }}
                                                    checked={
                                                      filtersForPractice &&
                                                      filtersForPractice.netTotal &&
                                                      filtersForPractice.netTotal.indexOf(
                                                        option.value,
                                                      ) > -1
                                                        ? true
                                                        : false
                                                    }
                                                  />
                                                  {option.title}
                                                </React.Fragment>
                                              )}
                                              renderInput={(params) => (
                                                <TextField
                                                  {...params}
                                                  variant="outlined"
                                                  label="Cell"
                                                />
                                              )}
                                              popupIcon={<ExpandMoreIcon />}
                                            />
                                          </Grid>

                                          <Grid item xs={12} sm={4} md={1}>
                                            <Button
                                              type="New Message"
                                              className={classes.button}
                                              variant="outlined"
                                            >
                                              APPLY
                                            </Button>
                                          </Grid>
                                          <Grid item xs={12} sm={4} md={1}>
                                            <Box
                                              display="flex"
                                              alignItems="center"
                                              height={1}
                                              className={classes.clearbtn}
                                            >
                                              CLEAR
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </Grid>

                                      <Grid spacing={4} xs={12}>
                                        <div className="selectedTags">{''}</div>
                                      </Grid>
                                    </Grid>
                                  </Grid>
                                  <>
                                   
                                  
                                   
                                    {/* This View Is For Operations/Invoicing End */}
                                    {/* This View Is For Operations/Forms Start */}
                                    <Grid item xs={12}>
                                      <Grid container>
                                        <Grid item xs={12} className={classes.innercontentWhite}>
                                          <Grid container direction="row" alignItems="center">
                                            <Box
                                              width={1}
                                              display="flex"
                                              justifyContent="space-between"
                                              alignItems="center"
                                              flexWrap="wrap"
                                            >
                                              <Box
                                                display="flex"
                                                flexWrap="wrap"
                                                alignItems="center"
                                              >
                                                <Grid item align="left">
                                                  <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    alignItems="center"
                                                    width={1}
                                                  >
                                                    <Typography variant="h5">
                                                      Performance Review Summary & 360 Peers Review
                                                      Report
                                                    </Typography>
                                                  </Box>
                                                </Grid>
                                              </Box>
                                              {/* Material Table */}
                                              {/* <MaterialTable
                                                style={{
                                                  boxShadow: 'none',
                                                  width: '100%',
                                                }}
                                                className={classes.materialDT}
                                                options={{
                                                  toolbar: false,
                                                  draggable: false,
                                                  paging: false,
                                                  sorting: true,
                                                  pageSize: 20,
                                                  pageSizeOptions: [10, 20, 50, 100],
                                                  showTextRowsSelected: false,
                                                  toolbarButtonAlignment: 'right',
                                                  showFirstLastPageButtons: false,
                                                  actionsColumnIndex: -100,
                                                  emptyRowsWhenPaging: false,
                                                }}
                                                localization={{
                                                  pagination: {
                                                    labelRowsSelect: 'Rows',
                                                    labelRowsPerPage: 'Rows Per Page',
                                                  },
                                                }}
                                                title="360 Peer Review"
                                                columns={[
                                                  {
                                                    title: 'Employee',
                                                    field: 'metric',
                                                    render: (data) => data.metric,
                                                  },
                                                  {
                                                    title: 'Metric',
                                                    field: 'myresult',
                                                    render: (data) => data.myresult,
                                                  },
                                                  {
                                                    title: 'Link to Form',
                                                    field: 'myrank',
                                                    render: (data) => (
                                                      <Link
                                                        color="textPrimary"
                                                        href="/#/app/dashboard/performance-review-summary-report/1"
                                                      >
                                                        {data.myrank}
                                                      </Link>
                                                    ),
                                                  },
                                                ]}
                                                data={[
                                                  {
                                                    metric: 'Lisa Lombardi',
                                                    myresult: '100',
                                                    myrank: 'Form',
                                                  },
                                                  {
                                                    metric: 'Trevor Roberts ',
                                                    myresult: '100',
                                                    myrank: 'Form',
                                                  },
                                                  {
                                                    metric: 'Jane Ki',
                                                    myresult: '100',
                                                    myrank: 'Form',
                                                  },
                                                  {
                                                    metric: 'Leslie Knope ',
                                                    myresult: '100',
                                                    myrank: 'Form',
                                                  },
                                                  {
                                                    metric: 'Ron Swanson',
                                                    myresult: '100',
                                                    myrank: 'Form',
                                                  },
                                                ]}
                                              /> */}
                                               <MaterialTable
                            style={{ boxShadow: 'none', width: '100%', }}
                            className={classes.materialDT}
                            options={{
                              toolbar: false,
                              draggable: false,
                              paging: true,
                              sorting: true,
                              pageSize: 20,
                              pageSizeOptions: [10, 20, 50, 100],
                              showTextRowsSelected: false,
                              toolbarButtonAlignment: 'right',
                              showFirstLastPageButtons: false,
                              actionsColumnIndex: -100,
                              emptyRowsWhenPaging: false,
                            }}
                            localization={{
                              pagination: {
                                labelRowsSelect: 'Rows',
                                labelRowsPerPage: 'Rows Per Page',
                              },
                            }}
                            title="Incomplete Forms "
                            columns={[
                              {
                                title: 'Employee',
                                field: 'AssignedFor',
                                render: (data) =>
                                  typeof data?.sentForUserDetails?.firstName == 'undefined'
                                    ? ''
                                    : data?.sentForUserDetails?.firstName +
                                      ' ' +
                                      data?.sentForUserDetails?.lastName,
                              },
                              {
                                title: 'Metric',
                                field: 'metric',
                                render: (data) =>
                                  100
                              },
                              {
                                title: 'Link to Form',
                                field: 'form',

                                render: (data) => ( <a
                                  onClick={() => {
                                    navigate(
                                      '../dashboard/performance-review-summary-report/' +
                                        data?.id +
                                        '/' +
                                        data?.sentForUserDetails?.id +
                                        '/' +
                                        moment(data?.creaedAt).format('YYYY'),
                                    );
                                  }}
                                >
                                  {' '}
                                  <Typography noWrap>Form</Typography>
                                </a>)
                                 
                                 
                              },

                             
                            
                            
                            ]}
                            data={performanceReview || []}
                          />
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                      <Grid container>
                                        <Grid item xs={12} className={classes.innercontentWhite}>
                                          <Grid container direction="row" alignItems="center">
                                            <Box
                                              width={1}
                                              display="flex"
                                              justifyContent="space-between"
                                              alignItems="center"
                                              flexWrap="wrap"
                                            >
                                              <Box
                                                display="flex"
                                                flexWrap="wrap"
                                                alignItems="center"
                                              >
                                                <Grid item align="left">
                                                  <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    alignItems="center"
                                                    width={1}
                                                  >
                                                    <Typography variant="h5">
                                                      Client Survey
                                                    </Typography>
                                                  </Box>
                                                </Grid>
                                              </Box>
                                              {/* Material Table */}
                                              <MaterialTable
                                                style={{
                                                  boxShadow: 'none',
                                                  width: '100%',
                                                }}
                                                className={classes.materialDT}
                                                options={{
                                                  toolbar: false,
                                                  draggable: false,
                                                  paging: false,
                                                  sorting: true,
                                                  pageSize: 20,
                                                  pageSizeOptions: [10, 20, 50, 100],
                                                  showTextRowsSelected: false,
                                                  toolbarButtonAlignment: 'right',
                                                  showFirstLastPageButtons: false,
                                                  actionsColumnIndex: -100,
                                                  emptyRowsWhenPaging: false,
                                                }}
                                                localization={{
                                                  pagination: {
                                                    labelRowsSelect: 'Rows',
                                                    labelRowsPerPage: 'Rows Per Page',
                                                  },
                                                }}
                                                title="Client Survey"
                                                columns={[
                                                  {
                                                    title: 'Employee',
                                                    field: 'metric',
                                                    render: (data) => data.metric,
                                                  },
                                                  {
                                                    title: 'Metric',
                                                    field: 'myresult',
                                                    render: (data) => data.myresult,
                                                  },
                                                  {
                                                    title: 'Link to Form',
                                                    field: 'myrank',
                                                    render: (data) => data.myrank,
                                                   
                                                  },
                                                ]}
                                                data={[
                                                  {
                                                    metric: 'Lisa Lombardi',
                                                    myresult: '100',
                                                    myrank: 'Form is unavailable',
                                                    //tooltip: 'Save User',
                                                  },
                                                  {
                                                    metric: 'Trevor Roberts ',
                                                    myresult: '100',
                                                    myrank: 'Form is unavailable',
                                                  },
                                                  {
                                                    metric: 'Jane Ki',
                                                    myresult: '100',
                                                    myrank: 'Form is unavailable',
                                                  },
                                                  {
                                                    metric: 'Leslie Knope ',
                                                    myresult: '100',
                                                    myrank: 'Form is unavailable',
                                                  },
                                                  {
                                                    metric: 'Ron Swanson',
                                                    myresult: '100',
                                                    myrank: 'Form is unavailable',
                                                  },
                                                ]}
                                              />
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid item xs={12}>
                                      <Grid container>
                                        <Grid item xs={12} className={classes.innercontentWhite}>
                                          <Grid container direction="row" alignItems="center">
                                            <Box
                                              width={1}
                                              display="flex"
                                              justifyContent="space-between"
                                              alignItems="center"
                                              flexWrap="wrap"
                                            >
                                              <Box
                                                display="flex"
                                                flexWrap="wrap"
                                                alignItems="center"
                                              >
                                                <Grid item align="left">
                                                  <Box
                                                    display="flex"
                                                    justifyContent="space-between"
                                                    alignItems="center"
                                                    width={1}
                                                  >
                                                    <Typography variant="h5">
                                                      Supervisor Score
                                                    </Typography>
                                                  </Box>
                                                </Grid>
                                              </Box>
                                              {/* Material Table */}
                                              <MaterialTable
                                                style={{
                                                  boxShadow: 'none',
                                                  width: '100%',
                                                }}
                                                className={classes.materialDT}
                                                options={{
                                                  toolbar: false,
                                                  draggable: false,
                                                  paging: false,
                                                  sorting: true,
                                                  pageSize: 20,
                                                  pageSizeOptions: [10, 20, 50, 100],
                                                  showTextRowsSelected: false,
                                                  toolbarButtonAlignment: 'right',
                                                  showFirstLastPageButtons: false,
                                                  actionsColumnIndex: -100,
                                                  emptyRowsWhenPaging: false,
                                                }}
                                                localization={{
                                                  pagination: {
                                                    labelRowsSelect: 'Rows',
                                                    labelRowsPerPage: 'Rows Per Page',
                                                  },
                                                }}
                                                title="Supervisor Score"
                                                columns={[
                                                  {
                                                    title: 'Employee',
                                                    field: 'metric',
                                                    render: (data) => data.metric,
                                                  },
                                                  {
                                                    title: 'Metric',
                                                    field: 'myresult',
                                                    render: (data) => data.myresult,
                                                  },
                                                  {
                                                    title: 'Link to Form',
                                                    field: 'myrank',
                                                    render: (data) => data.myrank,
                                                  },
                                                ]}
                                                data={[
                                                  {
                                                    metric: 'Lisa Lombardi',
                                                    myresult: '100',
                                                    myrank: 'Form is unavailable',
                                                  },
                                                  {
                                                    metric: 'Trevor Roberts ',
                                                    myresult: '100',
                                                    myrank: 'Form is unavailable',
                                                  },
                                                  {
                                                    metric: 'Jane Ki',
                                                    myresult: '100',
                                                    myrank: 'Form is unavailable',
                                                  },
                                                  {
                                                    metric: 'Leslie Knope ',
                                                    myresult: '100',
                                                    myrank: 'Form is unavailable',
                                                  },
                                                  {
                                                    metric: 'Ron Swanson',
                                                    myresult: '100',
                                                    myrank: 'Form is unavailable',
                                                  },
                                                ]}
                                              />
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      </Grid>
                                    </Grid>
                           
                                  </>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Grid>
    </>
  );
};
export default EmployeeScoreTable;
